import Url from '@music/mobile-url';

const map = {
    '#/upload': '/st/creator/upload/video',
    '#/datacenter': '/st/creator/datacenter',
    '#/welcome': '/st/creator/'
};

export default function redirect({ type, companyParticipateState }) {
    if (type === 2 && companyParticipateState === 2) return; // 公司账户不做重定向
    const hash = window.location.hash;
    const search = window.location.search;
    const keys = Object.keys(map).filter(key => hash.indexOf(key) > -1);

    if (keys.length > 0) {
        const prefix = map[keys[0]];
        window.location.href = Url.CurrentHost + prefix + search;
    }
}


// 需要特殊重定向的路由
const needSpecificRedirect = {
    '/st/creator/datacenter#/': 'data-center',
    '/st/creator/datacenter/djradio/voice#/': 'data-center',
    '/st/creator/datacenter/djradio/voicelist#/': 'data-center?userType=3&podcast=0',
    '/st/creator/fan#/': 'fansdata',
    '/st/creator/moneypackage#/': 'revenue-my',
    '/uservideo#/plan': 'revenue-my',
    '/st/radioweb/revenue#/': 'revenue-my',
    '/uservideo#/myvideo': 'manage/video',
    '/uservideo#/myvideo?statusIndex=0&tabIndex=2': 'manage/video?statusIndex=0&tabIndex=2',
    '/uservideo#/myvideo?statusIndex=1&tabIndex=2': 'manage/video?statusIndex=1&tabIndex=2',
    '/uservideo#/myvideo?statusIndex=2&tabIndex=2': 'manage/video?statusIndex=2&tabIndex=2',
    '/uservideo#/myvideo?statusIndex=0&tabIndex=1': 'manage/video?statusIndex=0&tabIndex=1',
    '/uservideo#/myvideo?statusIndex=1&tabIndex=1': 'manage/video?statusIndex=1&tabIndex=1',
    '/uservideo#/myvideo?statusIndex=0&tabIndex=0': 'manage/video?statusIndex=0&tabIndex=0',
    '/uservideo#/myvideo?statusIndex=1&tabIndex=0': 'manage/video?statusIndex=1&tabIndex=0',
    '/st/radioweb/voice/display#/': 'manage/voice/display',
    '/st/radioweb/voicelist/display#/': 'manage/voicelist/display',
    '/st/creator/upload/video#/': 'upload?userType=1',
    '/st/radioweb/publish/voice#/': 'upload?userType=3',
    '/st/radioweb/voicelist/create#/': 'manage/voicelist/create',
    '/st/radioweb/talentplan#/': 'privilege-list',
    '/uservideo#/talent': 'privilege-list',
};

// 黑胶故事页 hash动态可变 要特殊判断
const vinylUrl = '/uservideo#/musicbgvideo';

// 项目废弃重定向到新工程逻辑
export const redirectToNewProject = () => {
    let redirectUrl = '/st/ncreator';
    const oldUrl = `${window.location.pathname}${window.location.hash}`;
    const newUrl = needSpecificRedirect[oldUrl] || needSpecificRedirect[`${oldUrl}#/`];
    if (newUrl !== undefined) {
        redirectUrl = `/st/ncreator/${newUrl}`;
    } else if (oldUrl.includes(vinylUrl)) {
        const params = new URLSearchParams(`?${window.location.hash.split('?')[1]}`);
        const songId = params.get('songId');
        redirectUrl = `/st/ncreator/music-bg-video?songId=${songId}`;
    }
    window.location.replace(`${window.location.origin}${redirectUrl}`);
};



// WEBPACK FOOTER //
// ./client/util/redirect.js